import { render, staticRenderFns } from "./bankwallet.vue?vue&type=template&id=036ae504&scoped=true&"
import script from "./bankwallet.vue?vue&type=script&lang=js&"
export * from "./bankwallet.vue?vue&type=script&lang=js&"
import style0 from "./bankwallet.vue?vue&type=style&index=0&id=036ae504&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036ae504",
  null
  
)

export default component.exports